<template>
	<div v-if="brands">
		<!-- <slick v-if="this.window.window>768 " v-bind="slickOptions">
      <CardWithHover v-for="(item,i) in brands" :key="i" :item="item"
          />
      
    </slick> -->
		<slick ref="slick" :options="slickOptions1">
			<CardWithHover v-for="(item, i) in brands" :key="i" :item="item" />
		</slick>
	</div>

	<!-- <section v-if="this.$store.state.Banner.length">
    <slick ref="slick" :options="slickOptions">
      <a :href="item.url" v-for="(item,i) in this.$store.state.Banner" :key="i" ><img :src="item.image" :alt="item.title" :title="item.title" class="w-100"></a>
    </slick>  -->
	<!-- </section> -->
</template>
<style >
	@import "../../../node_modules/slick-carousel/slick/slick.css";
	/* .slick-dots {
				    position: absolute;
				    bottom: 25px !important;
				    display: block;
				    width: 100%;
				    padding: 0;
				    margin: 0;
				    list-style: none;
				    text-align: center;
				}
				.slick-dots li button:before {
				  font-size: 15px !important;
				} */
	.BrandBox {
		width: 90%;
		margin-left: 5%;
	}
	/* Responsive  */
	@media screen and (max-width: 767px) {
		.BrandBox {
			width: 100%;
			margin-left: 0px;
		}
		/* .slick-slider{
				    margin-left: -50px;
				  } */
		.slick-track {
			margin-left: auto;
			margin-right: auto;
			transform: translate3d(5px, 0px, 0px);
		}
	}
</style>

<script>
	import slick from "vue-slick";

	// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
	// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
	import CardWithHover from "../Home/CardWithHover";

	export default {
		name: "brand",
		components: { slick, CardWithHover },
		mounted() {
			window.addEventListener("resize", this.handleResize);
			this.handleResize();
		},
		destroyed() {
			window.removeEventListener("resize", this.handleResize);
		},
		props: ["brands"],
		methods: {
			handleResize() {
				this.window.width = window.innerWidth;
				this.window.height = window.innerHeight;
			},
		},

		data() {
			return {
				window: {
					width: 0,
					height: 0,
				},
				img: [
					"/_nuxt/assets/img/1_3.jpg",
					"/_nuxt/assets/img/1_2.jpg",
					"/_nuxt/assets/img/1_4.jpg",
					"/_nuxt/assets/img/1.jpg",
					"/_nuxt/assets/img/1_2.jpg",
					"/_nuxt/assets/img/1_3.jpg",
					"/_nuxt/assets/img/1_4.jpg",
					"/_nuxt/assets/img/1.jpg",
				],
				slickOptions1: {
					slidesToShow: 4,
					infinite: false,
					dot: true,
					swipeToSlide: true,
					beforeChange: () => (dragging = true),
					afterChange: () => (dragging = false),
					responsive: [
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 4,
								slidesToScroll: 4,
								// centerMode: true,
								// centerPadding: '65px'
							},
						},
						{
							breakpoint: 767,
							settings: {
								arrows: false,
								slidesToShow: 2.15,
								slidesToScroll: 2.15,
								// centerMode: true,
								// centerPadding: '0px'
							},
						},
					],
					// Any other options that can be got from plugin documentation
				},
			};
		},
	};
</script>